import {Component, OnDestroy, OnInit} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from "@angular/router";
import {CurrentRouteService} from "../currentRoute.service";
import { ForgotPasswordConfirmationService } from './forgot-password-confirmation.service';
import {ModelValidators} from '../validators/validators';

@Component({
  selector: 'app-forgot-password-confirmation',
  templateUrl: './forgot-password-confirmation.component.html',
  styleUrls: ['./forgot-password-confirmation.component.css']
})
export class ForgotPasswordConfirmationComponent implements OnInit {

  hide: boolean = true;
  myForm: UntypedFormGroup;
  is_form_error: boolean = false;
  form_error_message:string = '';
  is_loading = false;

  constructor(private forgotPasswordConfirmationService: ForgotPasswordConfirmationService,
              private fb: UntypedFormBuilder,
              public router: Router,
              private route: ActivatedRoute,
              private currentrouteService: CurrentRouteService,) { }

  ngOnInit(): void {
    localStorage.clear();
    sessionStorage.clear();
    this.currentrouteService.announceCurrentRoute(this.router.url);
    this.myForm = this.fb.group({
      email: ['', Validators.required],
      code: ['', Validators.required],
      password: ['', [Validators.required, ModelValidators.passwordControls]],
    })//end myForm
  }

  onFocus(){
    this.is_form_error = false;
    this.form_error_message = null;
  }

  onSubmit(): void {

    this.is_loading = true;
    let endpoint = 'password-forgot-confirmation';
    this.forgotPasswordConfirmationService.forgotPasswordConfirmation(endpoint,
      this.myForm.value.email,
      this.myForm.value.code,
      this.myForm.value.password)
      .subscribe(
        data => {
          console.log(data);
          this.is_loading = false;
          this.router.navigate(['/login']);
        },
        error => {
          console.log(error);
          this.is_loading = false;
          this.is_form_error = true;
          this.form_error_message = error
        }
      );
  }

}
